export const translations = {
  sessionTimeoutError: {
    description: {
      en: 'Hello. It looks like you have been idle for some time. You need to login again.',
      es: 'Hola. Parece que hace mucho que no vienes. Tienes que volver a iniciar sesión.',
      ar: 'مرحبًا. يبدو أنك كنت خاملاً لبعض الوقت. تحتاج إلى تسجيل الدخول مرة أخرى.',
      he: 'Hello. It looks like you have been idle for some time. You need to login again.',
      fr: 'Bonjour. Il semble que vous ayez été inactif pendant un certain temps. Vous devez vous reconnecter.',
      ro: 'Bună. Se pare că ați fost inactiv de ceva timp. Trebuie să vă autentificați din nou.',
      nl: 'Hallo. Het lijkt erop dat je een tijdje niets hebt gedaan. Je moet opnieuw inloggen.',
      pl: 'Witaj. Wygląda na to, że byłeś nieaktywny przez jakiś czas. Musisz zalogować się ponownie.',
    },
    message: {
      en: 'Sorry! The session expired',
      es: 'La sesión ha expirado.',
      ar: 'آسف! انتهت الجلسة',
      he: 'Sorry! The session expired',
      fr: 'Désolé ! La session a expiré',
      ro: 'Ne pare rău! Sesiunea a expirat',
      nl: 'Sorry! De sessie is verlopen',
      pl: 'Przepraszamy! Sesja wygasła',
    },
  },
  errorResponse: {
    message: {
      en: 'Something went wrong while fetching your request',
      es: 'Tu solicitud no se puede completar.',
      ar: 'حدث خطأ ما أثناء جلب طلبك',
      he: 'Something went wrong while fetching your request',
      fr: 'Un problème est survenu lors de la récupération de votre demande',
      ro: 'Ceva nu a mers bine la preluarea cererii dvs.',
      nl: 'Er is iets misgegaan bij het ophalen van je verzoek',
      pl: 'Coś poszło nie tak podczas pobierania Twojego żądania',
    },
    description: {
      en: 'If this persists, please try again later or contact support',
      es: 'Si el problema persiste, inténtalo de nuevo más tarde o contacta con el equipo de soporte.',
      ar: 'إذا استمر هذا ، يرجى المحاولة مرة أخرى لاحقًا أو الاتصال بالدعم',
      he: 'If this persists, please try again later or contact support',
      fr: 'Si cela persiste, veuillez réessayer plus tard ou contacter le support',
      ro: 'Dacă problema persistă, încercați din nou mai târziu sau contactați asistența',
      nl: 'Als dit aanhoudt, probeer het later opnieuw of neem contact op met de ondersteuning',
      pl: 'Jeśli problem będzie się utrzymywał, spróbuj ponownie później lub skontaktuj się z pomocą techniczną',
    },
    status400: {
      message: {
        en: 'Something went wrong!',
        es: 'Algo ha salido mal.',
        ar: 'هناك خطأ ما!',
        he: 'Something went wrong!',
        fr: 'Quelque chose a mal tourné !',
        ro: 'Ceva nu a mers bine!',
        nl: 'Er is iets misgegaan!',
        pl: 'Coś poszło nie tak!',
      },
      description: {
        en: 'Please double check your inputs or retry.',
        es: 'Comprueba lo que has hecho o inténtalo de nuevo.',
        ar: 'يرجى التحقق مرة أخرى من أفعالك أو إعادة المحاولة.',
        he: 'Please double check your inputs or retry.',
        fr: 'Veuillez vérifier vos entrées ou réessayer.',
        ro: 'Vă rugăm să verificați din nou informațiile introduse sau să încercați din nou.',
        nl: 'Controleer je invoer nogmaals of probeer het opnieuw.',
        pl: 'Proszę dokładnie sprawdzić wprowadzone dane lub spróbować ponownie.',
      },
    },
    status403: {
      message: {
        en: 'This request has been blocked!',
        es: '¡Esta solicitud ha sido bloqueada!',
        ar: 'تم حظر هذا الطلب!',
        he: 'הבקשה נחסמה!',
        fr: 'Cette demande a été bloquée !',
        ro: 'Această solicitare a fost blocată!',
        nl: 'Dit verzoek is geblokkeerd!',
        pl: 'To żądanie zostało zablokowane!',
      },
      description: {
        en: 'Sorry, this request is forbidden. Please contact support for assistance.',
        es: 'Lo sentimos, esta solicitud está prohibida. Contacta con el servicio de asistencia para obtener ayuda.',
        ar: 'عذرًا، هذا الطلب محظور. يرجى التواصل مع الدعم للمساعدة.',
        he: 'מצטערים, הבקשה אסורה. אנא פנה לתמיכה לעזרה.',
        fr: "Désolé, cette demande est interdite. Veuillez contacter le support pour obtenir de l'aide.",
        ro: 'Ne pare rău, această solicitare este interzisă. Vă rugăm să contactați suportul pentru asistență.',
        nl: 'Sorry, dit verzoek is verboden. Neem contact op met de ondersteuning voor hulp.',
        pl: 'Przepraszamy, to żądanie jest zabronione. Proszę skontaktować się z pomocą techniczną.',
      },
    },
    status404: {
      message: {
        en: 'Sorry, we could not process your request',
        es: 'No hemos podido procesar tu solicitud.',
        ar: 'عذرا ، لم نتمكن من معالجة طلبك',
        he: 'Sorry, we could not process your request',
        fr: "Désolé, nous n'avons pas pu traiter votre demande",
        ro: 'Ne pare rău, nu am putut procesa cererea dvs.',
        nl: 'Sorry, we konden je verzoek niet verwerken',
        pl: 'Przepraszamy, nie mogliśmy przetworzyć Twojego żądania',
      },
      description: {
        en: 'Please try again later or contact support. Thank you.',
        es: 'Inténtalo de nuevo más tarde o contacta con el equipo de soporte. Gracias.',
        ar: 'يرجى المحاولة مرة أخرى في وقت لاحق أو الاتصال بالدعم. شكرًا لك.',
        he: 'Please try again later or contact support. Thank you.',
        fr: 'Veuillez réessayer plus tard ou contacter le support. Merci.',
        ro: 'Vă rugăm să încercați din nou mai târziu sau să contactați asistența. Mulțumim.',
        nl: 'Probeer het later opnieuw of neem contact op met de ondersteuning. Bedankt.',
        pl: 'Proszę spróbować ponownie później lub skontaktować się z pomocą techniczną. Dziękujemy.',
      },
    },
    errNetwork: {
      message: {
        en: 'Sorry! No internet detected',
        es: 'Sin conexión a internet.',
        ar: 'آسف! لم يتم الكشف عن الإنترنت',
        he: 'Sorry! No internet detected',
        fr: 'Désolé ! Aucun accès à Internet détecté',
        ro: 'Ne pare rău! Nu a fost detectată conexiune la internet',
        nl: 'Sorry! Geen internet gedetecteerd',
        pl: 'Przepraszamy! Nie wykryto połączenia z internetem',
      },
      description: {
        en: 'Please check your internet connection and retry.',
        es: 'Comprueba tu conexión a internet e inténtalo de nuevo.',
        ar: 'يرجى التحقق من اتصالك بالإنترنت وإعادة المحاولة.',
        he: 'Please check your internet connection and retry.',
        fr: 'Veuillez vérifier votre connexion Internet et réessayer.',
        ro: 'Vă rugăm să verificați conexiunea la internet și să încercați din nou.',
        nl: 'Controleer je internetverbinding en probeer het opnieuw.',
        pl: 'Proszę sprawdzić połączenie internetowe i spróbować ponownie.',
      },
    },
    econnAborted: {
      message: {
        en: 'Oops! This has taken longer than usual! Our bad!',
        es: '¡Vaya! Está tardando más de lo habitual. ¡Culpa nuestra!',
        ar: 'أُووبس! لقد استغرق هذا وقتا أطول من المعتاد! سيئنا!',
        he: 'Oops! This has taken longer than usual! Our bad!',
        fr: "Oups ! Cela a pris plus de temps que d'habitude ! Notre erreur !",
        ro: 'Ups! A durat mai mult decât de obicei! Ne pare rău!',
        nl: 'Oeps! Dit duurde langer dan normaal! Onze fout!',
        pl: 'Ups! To trwało dłużej niż zwykle! Nasza wina!',
      },
      description: {
        en: 'Might be a slow connection. Please try again or retry later.',
        es: 'Puede que tu conexión sea lenta. Inténtalo de nuevo o prueba más tarde.',
        ar: '.قد يكون الاتصال بطيئا. يرجى المحاولة مرة أخرى أو المحاولة لاحقًا',
        he: 'Might be a slow connection. Please try again or retry later.',
        fr: "Il pourrait s'agir d'une connexion lente. Veuillez réessayer ou réessayer plus tard.",
        ro: 'S-ar putea să fie o conexiune lentă. Vă rugăm să încercați din nou sau mai târziu.',
        nl: 'Het kan een trage verbinding zijn. Probeer het opnieuw of later nog eens.',
        pl: 'Może to być wolne połączenie. Proszę spróbować ponownie lub później.',
      },
    },
  },
};
